export default "__VITE_ASSET__96d41808__"